function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _class, _temp;

var _require = require('@uppy/core'),
    UIPlugin = _require.UIPlugin;

var getSpeed = require('@uppy/utils/lib/getSpeed');

var getBytesRemaining = require('@uppy/utils/lib/getBytesRemaining');

var getTextDirection = require('@uppy/utils/lib/getTextDirection');

var statusBarStates = require('./StatusBarStates');

var StatusBarUI = require('./StatusBar');

var locale = require('./locale.js');
/**
 * StatusBar: renders a status bar with upload/pause/resume/cancel/retry buttons,
 * progress percentage and time remaining.
 */


module.exports = (_temp = _class = /*#__PURE__*/function (_UIPlugin) {
  _inherits(StatusBar, _UIPlugin);

  var _super = _createSuper(StatusBar);

  // eslint-disable-next-line global-require
  function StatusBar(uppy, opts) {
    var _this;

    _classCallCheck(this, StatusBar);

    _this = _super.call(this, uppy, opts);

    _this.startUpload = function () {
      var _this$uppy$getState = _this.uppy.getState(),
          recoveredState = _this$uppy$getState.recoveredState;

      if (recoveredState) {
        _this.uppy.emit('restore-confirmed');

        return undefined;
      }

      return _this.uppy.upload().catch(function () {// Error logged in Core
      });
    };

    _this.id = _this.opts.id || 'StatusBar';
    _this.title = 'StatusBar';
    _this.type = 'progressindicator';
    _this.defaultLocale = locale; // set default options

    var defaultOptions = {
      target: 'body',
      hideUploadButton: false,
      hideRetryButton: false,
      hidePauseResumeButton: false,
      hideCancelButton: false,
      showProgressDetails: false,
      hideAfterFinish: true,
      doneButtonHandler: null
    };
    _this.opts = _objectSpread(_objectSpread({}, defaultOptions), opts);

    _this.i18nInit();

    _this.render = _this.render.bind(_assertThisInitialized(_this));
    _this.install = _this.install.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(StatusBar, [{
    key: "render",
    value: function render(state) {
      var capabilities = state.capabilities,
          files = state.files,
          allowNewUpload = state.allowNewUpload,
          totalProgress = state.totalProgress,
          error = state.error,
          recoveredState = state.recoveredState;

      var _this$uppy$getObjectO = this.uppy.getObjectOfFilesPerState(),
          newFiles = _this$uppy$getObjectO.newFiles,
          startedFiles = _this$uppy$getObjectO.startedFiles,
          completeFiles = _this$uppy$getObjectO.completeFiles,
          inProgressNotPausedFiles = _this$uppy$getObjectO.inProgressNotPausedFiles,
          isUploadStarted = _this$uppy$getObjectO.isUploadStarted,
          isAllComplete = _this$uppy$getObjectO.isAllComplete,
          isAllErrored = _this$uppy$getObjectO.isAllErrored,
          isAllPaused = _this$uppy$getObjectO.isAllPaused,
          isUploadInProgress = _this$uppy$getObjectO.isUploadInProgress,
          isSomeGhost = _this$uppy$getObjectO.isSomeGhost; // If some state was recovered, we want to show Upload button/counter
      // for all the files, because in this case it’s not an Upload button,
      // but “Confirm Restore Button”


      var newFilesOrRecovered = recoveredState ? Object.values(files) : newFiles;
      var totalETA = getTotalETA(inProgressNotPausedFiles);
      var resumableUploads = !!capabilities.resumableUploads;
      var supportsUploadProgress = capabilities.uploadProgress !== false;
      var totalSize = 0;
      var totalUploadedSize = 0;
      startedFiles.forEach(function (file) {
        totalSize += file.progress.bytesTotal || 0;
        totalUploadedSize += file.progress.bytesUploaded || 0;
      });
      return StatusBarUI({
        error: error,
        uploadState: getUploadingState(error, isAllComplete, recoveredState, state.files || {}),
        allowNewUpload: allowNewUpload,
        totalProgress: totalProgress,
        totalSize: totalSize,
        totalUploadedSize: totalUploadedSize,
        isAllComplete: false,
        isAllPaused: isAllPaused,
        isAllErrored: isAllErrored,
        isUploadStarted: isUploadStarted,
        isUploadInProgress: isUploadInProgress,
        isSomeGhost: isSomeGhost,
        recoveredState: recoveredState,
        complete: completeFiles.length,
        newFiles: newFilesOrRecovered.length,
        numUploads: startedFiles.length,
        totalETA: totalETA,
        files: files,
        i18n: this.i18n,
        uppy: this.uppy,
        startUpload: this.startUpload,
        doneButtonHandler: this.opts.doneButtonHandler,
        resumableUploads: resumableUploads,
        supportsUploadProgress: supportsUploadProgress,
        showProgressDetails: this.opts.showProgressDetails,
        hideUploadButton: this.opts.hideUploadButton,
        hideRetryButton: this.opts.hideRetryButton,
        hidePauseResumeButton: this.opts.hidePauseResumeButton,
        hideCancelButton: this.opts.hideCancelButton,
        hideAfterFinish: this.opts.hideAfterFinish,
        isTargetDOMEl: this.isTargetDOMEl
      });
    }
  }, {
    key: "onMount",
    value: function onMount() {
      // Set the text direction if the page has not defined one.
      var element = this.el;
      var direction = getTextDirection(element);

      if (!direction) {
        element.dir = 'ltr';
      }
    }
  }, {
    key: "install",
    value: function install() {
      var target = this.opts.target;

      if (target) {
        this.mount(target, this);
      }
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this.unmount();
    }
  }]);

  return StatusBar;
}(UIPlugin), _class.VERSION = "2.1.3", _temp);

function getTotalSpeed(files) {
  var totalSpeed = 0;
  files.forEach(function (file) {
    totalSpeed += getSpeed(file.progress);
  });
  return totalSpeed;
}

function getTotalETA(files) {
  var totalSpeed = getTotalSpeed(files);

  if (totalSpeed === 0) {
    return 0;
  }

  var totalBytesRemaining = files.reduce(function (total, file) {
    return total + getBytesRemaining(file.progress);
  }, 0);
  return Math.round(totalBytesRemaining / totalSpeed * 10) / 10;
}

function getUploadingState(error, isAllComplete, recoveredState, files) {
  if (error && !isAllComplete) {
    return statusBarStates.STATE_ERROR;
  }

  if (isAllComplete) {
    return statusBarStates.STATE_COMPLETE;
  }

  if (recoveredState) {
    return statusBarStates.STATE_WAITING;
  }

  var state = statusBarStates.STATE_WAITING;
  var fileIDs = Object.keys(files);

  for (var i = 0; i < fileIDs.length; i++) {
    var progress = files[fileIDs[i]].progress; // If ANY files are being uploaded right now, show the uploading state.

    if (progress.uploadStarted && !progress.uploadComplete) {
      return statusBarStates.STATE_UPLOADING;
    } // If files are being preprocessed AND postprocessed at this time, we show the
    // preprocess state. If any files are being uploaded we show uploading.


    if (progress.preprocess && state !== statusBarStates.STATE_UPLOADING) {
      state = statusBarStates.STATE_PREPROCESSING;
    } // If NO files are being preprocessed or uploaded right now, but some files are
    // being postprocessed, show the postprocess state.


    if (progress.postprocess && state !== statusBarStates.STATE_UPLOADING && state !== statusBarStates.STATE_PREPROCESSING) {
      state = statusBarStates.STATE_POSTPROCESSING;
    }
  }

  return state;
}